import { CONSTANTS } from 'config';

export default function () {

  return function buildingUsage(type = '') {
    if (CONSTANTS.BUILDING_USAGE[type]) {
      return CONSTANTS.BUILDING_USAGE[type].name;
    }
    return '';
  };
}



// WEBPACK FOOTER //
// ./src/filters/buildingUsage.js